(() => {
  const root = document.querySelector('[data-sc-memory]');
  if (!root || root.dataset.memoryReady) return;
  root.dataset.memoryReady = 'true';
  const recent = root.dataset.source === 'recent';
  const key = recent ? 'sincere-recent-v1' : 'sincere-saved-v1';
  const limit = recent ? 12 : 20;
  const route = window.Shopify?.routes?.root || '/';
  const el = name => root.querySelector('[data-mem-' + name + ']');
  const grid = el('grid'), status = el('status'), empty = el('empty'), count = el('count');
  const retry = el('retry'), undo = el('undo'), notice = el('notice'), clear = el('clear');
  const copy = el('copy').dataset;
  const cache = new Map();
  let generation = 0, removed = [];
  function read() {
    const stored = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(stored)) throw Error('Invalid list');
    return [...new Set(stored.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)))].slice(0, limit);
  }
  function write(handles) {
    try { localStorage.setItem(key, JSON.stringify(handles)); return true; }
    catch { notice.textContent = copy.storage; return false; }
  }
  function refresh() {
    document.dispatchEvent(new CustomEvent('sc:cards-added'));
    document.dispatchEvent(new CustomEvent('sincere:saved-change', {detail: {source: 'memory-page'}}));
    return render();
  }
  function remove(handle) {
    let current;
    try { current = read(); } catch { notice.textContent = copy.storageRead; return; }
    const index = current.indexOf(handle);
    if (index < 0 || !write(current.filter(h => h !== handle))) return;
    removed = [{handle, index}];
    notice.textContent = copy.removed;
    undo.hidden = false;
    undo.focus({preventScroll: true});
    refresh();
  }
  async function card(handle) {
    if (cache.has(handle)) return {node: cache.get(handle)};
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(route + 'products/' + encodeURIComponent(handle) + '?section_id=product-memory-card', {signal: controller.signal});
      if (response.status === 404) return {gone: true};
      if (!response.ok) return {failed: true};
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = parsed.querySelector('[data-product-card]');
      if (!node) return {failed: true};
      cache.set(handle, node);
      return {node};
    } catch { return {failed: true}; }
    finally { clearTimeout(timer); }
  }
  function placeholder(handle, result) {
    const article = document.createElement('article');
    article.className = 'scMem__unavailable';
    const title = document.createElement('h2'), body = document.createElement('p'), button = document.createElement('button');
    title.textContent = handle.replaceAll('-', ' ');
    body.textContent = result.gone ? copy.unavailable : copy.interrupted;
    button.type = 'button';
    button.textContent = copy.remove;
    button.setAttribute('aria-label', copy.remove + ': ' + title.textContent);
    button.addEventListener('click', () => remove(handle));
    article.append(title, body, button);
    return article;
  }
  async function render() {
    const seq = ++generation;
    let handles;
    try { handles = read(); }
    catch { grid.removeAttribute('aria-busy'); status.textContent = copy.storageRead; retry.hidden = false; empty.hidden = true; if (clear) clear.hidden = true; return; }
    const cards = new Array(handles.length);
    let cursor = 0;
    empty.hidden = handles.length > 0;
    retry.hidden = true;
    if (clear) clear.hidden = !handles.length;
    grid.setAttribute('aria-busy', 'true');
    status.textContent = handles.length ? copy.loading : '';
    count.hidden = !handles.length;
    count.textContent = handles.length ? '(' + handles.length + ')' : '';
    await Promise.all(Array.from({length: Math.min(4, handles.length)}, async () => {
      while (cursor < handles.length) {
        const i = cursor++;
        cards[i] = await card(handles[i]);
        if (seq !== generation) return;
      }
    }));
    if (seq !== generation) return;
    grid.replaceChildren(...cards.map((result, i) => result.node ? result.node.cloneNode(true) : placeholder(handles[i], result)));
    grid.removeAttribute('aria-busy');
    const failed = cards.some(result => result.failed);
    status.textContent = failed ? copy.failed : '';
    retry.hidden = !failed;
    document.dispatchEvent(new CustomEvent('sc:cards-added'));
  }
  undo.addEventListener('click', () => {
    try {
      const current = read();
      const restored = [...current];
      removed.forEach(({handle, index}) => { if (!restored.includes(handle)) restored.splice(Math.min(index, restored.length), 0, handle); });
      if (restored.length > limit) { notice.textContent = copy.capacity; return; }
      if (!write(restored)) return;
      removed = [];
      undo.hidden = true;
      notice.textContent = '';
      refresh().then(() => root.querySelector('h1')?.focus({preventScroll: true}));
    } catch { notice.textContent = copy.storageRead; }
  });
  clear?.addEventListener('click', () => {
    try {
      const current = read();
      if (!write([])) return;
      removed = current.map((handle, index) => ({handle, index}));
      notice.textContent = copy.cleared;
      undo.hidden = false;
      undo.focus({preventScroll: true});
      refresh();
    } catch { notice.textContent = copy.storageRead; }
  });
  retry.addEventListener('click', () => { cache.clear(); render(); });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { cache.clear(); render(); } });
  document.addEventListener('sincere:saved-change', event => { if (!recent && event.detail?.source !== 'memory-page') render(); });
  render();
})();
